import * as React from "react";
import { AuthContext } from "duck";

const useAuth = () => React.useContext(AuthContext);

export default useAuth;
